<template>
  <div class="d-flex align-items-center">
    <div v-if="isSelected" class="fault-event" />
    <div class="event w-100" @click.stop.prevent="onEventSelection">
      <b-row>
        <b-col class="d-flex">
          <div class="device-view__attr">{{ timestampConverted }}</div>
          <div v-if="mappers[dataType]" class="device-view__attr">{{ mappers[dataType] }}</div>
        </b-col>
        <b-col v-if="isWaveform" md="auto" sm="2">
          <FaultFetchWaveformButton
            :is-loading="isLoading"
            :is-series-exist="isSeriesExist"
            @getWaveform="getWaveform"
            @showModal="showModal = true"
          />
          <b-modal
            v-if="isSeriesExist"
            v-model="showModal"
            hide-footer
            size="xl"
            title="Waveform"
            body-class="p-0"
            @click="showModal = !showModal"
          >
            <b-container>
              <FaultWaveforms v-bind="generatedWaveform" />
            </b-container>
          </b-modal>
        </b-col>
      </b-row>
      <b-col v-if="isWaveform" class="pl-0">
        <div class="attributes-list__label mb-1 mt-2">
          Reason
        </div>
        <div v-if="isWaveform" class="event__message">{{ reason || 'No reason provided' }}</div>
      </b-col>
    </div>
  </div>
</template>

<script>
import MomentTimezone from 'moment-timezone';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { FORMAT_YMD_HHMMSS_TIMEZONE } from '@/components/shared/date-format';
import FaultWaveforms from '@/components/substations/visnet-hubs/main-view/fault/fault-events-waveform-chart';
import FaultFetchWaveformButton from '@/components/shared/fault-fetch-waveform-button';

const MAPPERS = {
  current_voltage_wave: 'Current Voltage Waveform'
};

export default {
  name: 'FaultEvent',
  components: { FaultFetchWaveformButton, FaultWaveforms },
  props: {
    id: String,
    waveformId: String,
    externalVisnetHubId: String,
    projectCode: String,
    timestamp: Number,
    substationCode: String,
    dataType: String,
    phaseNumber: Number,
    feederNumber: Number,
    startPoint: Number,
    interval: Number,
    timestampStart: Number,
    timestampEnd: Number,
    reason: { type: String, default: 'Not present' },
    currentWaveValue: Array,
    voltageWaveValue: Array,
    waveformValue: Array,
    bestImpedance: Object,
    latestImpedance: Object,
    isWaveform: Boolean,
    createdAt: String,
    updatedAt: String
  },
  data() {
    return {
      mappers: MAPPERS,
      showModal: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getWaveformByID: 'visnetHubFaultEvents/getWaveform'
    }),
    ...mapState({
      eventTimestamp: state => state.visnetHubFaultWaveforms.eventTimestamp
    }),
    generatedWaveform() {
      const {
        createdAt,
        dataType,
        id,
        interval,
        isWaveform,
        startPoint,
        timestamp,
        timestampEnd,
        timestampStart
      } = this;

      return {
        series: this.getWaveformByID(this.waveformId),
        createdAt,
        dataType,
        id,
        interval,
        isWaveform,
        startPoint,
        timestamp,
        timestampEnd,
        timestampStart
      };
    },
    isSeriesExist() {
      return !!this.getWaveformByID(this.waveformId).length;
    },
    isSelected() {
      if (!this.eventTimestamp) return false;

      const { timestamp, id } = this.eventTimestamp;

      return timestamp === this.timestamp && id === this.id;
    },
    timestampConverted() {
      if (this.timestamp) {
        return MomentTimezone(this.timestamp * 1000).format(FORMAT_YMD_HHMMSS_TIMEZONE);
      }
      return MomentTimezone(this.createdAt).format(FORMAT_YMD_HHMMSS_TIMEZONE);
    }
  },
  methods: {
    ...mapActions({
      dispatchGetWaveform: 'visnetHubFaultEvents/fetchWaveform',
      dispatchFetchFaultElectricalData: 'visnetHubFaultElectricalData/fetchFaultElectricalData'
    }),
    ...mapMutations({
      setActiveEvent: 'visnetHubFaultWaveforms/setActiveEventTimestamp',
      setActiveEventTimestamp: 'visnetHubFaultWaveforms/setActiveEventTimestamp'
    }),
    async getWaveform() {
      this.isLoading = true;

      await this.dispatchGetWaveform({
        externalVisnetHubId: this.externalVisnetHubId,
        id: this.waveformId
      });

      this.isLoading = false;
    },
    onEventSelection(event) {
      if (event.target.innerName === 'Show Waveform') {
        return false;
      }
      if (event.target.classList.contains('modal')) {
        return false;
      }

      const {
        externalVisnetHubId,
        projectCode,
        substationCode,
        feederNumber,
        timestamp,
        id
      } = this;

      const payload = {
        externalVisnetHubId,
        projectCode,
        substationCode,
        feederNumber,
        timestamp: timestamp * 1000
      };

      this.dispatchFetchFaultElectricalData(payload);
      this.setActiveEventTimestamp({ id, timestamp });

      return true;
    }
  }
};
</script>
